import { useEffect } from "react";
import { useRouterState } from "@tanstack/react-router";
import { initializeAnalytics } from "@/lib/analytics";

/**
 * Mounts Google Analytics 4 once and reports one page_view per route change.
 * Renders nothing and never runs during SSR.
 */
export function Analytics() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  useEffect(() => {
    initializeAnalytics(pathname);
  }, [pathname]);

  return null;
}
